import React from "react";
import { SelectButton } from "../Form/Button";

function SectionSelector({ theme, btnOnClick, activeBtnID }) {
  return (
    <div className="selector">
      <div className="button-container">
        <SelectButton
          onClick={btnOnClick}
          btnText={theme.btn1}
          value={theme.img1Quote}
          className={activeBtnID === "1" ? "active-btn" : theme.btnClassName}
          name={1}
        />
        <SelectButton
          onClick={btnOnClick}
          btnText={theme.btn2}
          value={theme.img2Quote}
          className={activeBtnID === "2" ? "active-btn" : theme.btnClassName}
          name={2}
        />
        <SelectButton
          onClick={btnOnClick}
          btnText={theme.btn3}
          value={theme.img3Quote}
          className={activeBtnID === "3" ? "active-btn" : theme.btnClassName}
          name={3}
        />
      </div>
      <div className="card">
        <img
          src={theme[`img${activeBtnID}`]}
          alt={theme[`alt${activeBtnID}`]}
        />
      </div>
    </div>
  );
}

export default SectionSelector;
